import api from '@/shared/api/base-api';
import { IRegisterConfirmDTO } from '../model/types';

export const registerApi = {
  registerWithoutOTP: (data: IRegisterConfirmDTO) =>
    api.post('/v2/customers/register-without-otp', data),
};
